// Hero diaporama : fondu entre les slides, barres de progression cliquables, balayage au doigt,
// flèches du clavier. Lecture auto (si activée) : la barre active se remplit en CSS, la fin de son
// animation passe à la slide suivante ; pause au survol, au focus, hors écran et dans l'éditeur.
if (!customElements.get('dx-hero')) {
  customElements.define(
    'dx-hero',
    class DxHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.dx-hero__slide'));
        this.bars = Array.from(this.querySelectorAll('.dx-hero__bar'));
        if (this.slides.length < 2) return;
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        this.bars.forEach((bar, index) => bar.addEventListener('click', () => this.go(index)));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.go(this.index + 1);
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
        });
        this.initSwipe();

        const autoplay =
          this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (autoplay) {
          this.setAttribute('data-autoplay-on', '');
          this.addEventListener('animationend', (event) => {
            if (event.target.classList.contains('dx-hero__bar-fill')) this.go(this.index + 1);
          });
          this.addEventListener('mouseenter', () => this.setAttribute('data-hover', ''));
          this.addEventListener('mouseleave', () => this.removeAttribute('data-hover'));
          this.addEventListener('focusin', () => this.setAttribute('data-focus', ''));
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.removeAttribute('data-focus');
          });
          this.observer = new IntersectionObserver(([entry]) =>
            this.toggleAttribute('data-offscreen', !entry.isIntersecting)
          );
          this.observer.observe(this);

          this.pauseButton = this.querySelector('[data-dx-pause]');
          this.pauseButton?.addEventListener('click', () => {
            const paused = this.toggleAttribute('data-paused');
            this.pauseButton.textContent = paused
              ? this.pauseButton.dataset.playLabel
              : this.pauseButton.dataset.pauseLabel;
          });
        }

        // Customizer : la slide sélectionnée s'affiche et la lecture s'arrête pendant l'édition.
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('.dx-hero__slide'));
          if (index < 0) return;
          this.setAttribute('data-editing', '');
          this.go(index);
        });
        this.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-editing'));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      go(target) {
        const count = this.slides.length;
        const next = (target + count) % count;
        if (next === this.index) return;
        this.slides.forEach((slide, index) => {
          const active = index === next;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.bars.forEach((bar, index) => bar.setAttribute('aria-current', String(index === next)));
        this.index = next;
      }

      // Balayage horizontal au doigt (le défilement vertical de la page reste libre).
      initSwipe() {
        let startX = 0;
        let startY = 0;
        let tracking = false;
        const frame = this.querySelector('.dx-hero__frame');
        frame.addEventListener(
          'touchstart',
          (event) => {
            tracking = event.touches.length === 1;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        frame.addEventListener(
          'touchend',
          (event) => {
            if (!tracking) return;
            tracking = false;
            const dx = event.changedTouches[0].clientX - startX;
            const dy = event.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1));
          },
          { passive: true }
        );
      }
    }
  );
}
